// extracted by mini-css-extract-plugin
export default {"root":"_1iGzE","fade-in":"_1gHlZ","hide":"AgqhW","fade-out":"_2Ij7x","closeBtn":"_2JGHs"};